import React, { useState } from 'react'
import { PAGINATION_ICON_URL } from '../../constants/urls'

interface DropdownProps {
  children: React.ReactNode
  title: string
  onOpen?: () => void
  isPrivate?: boolean
  className?: string
}

const Dropdown: React.FC<DropdownProps> = ({ children, title, onOpen, isPrivate = false, className = '' }: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    if (onOpen) {
      onOpen()
    }
    if (isPrivate) {
      if (!localStorage.getItem('auth')) {
        setIsOpen(false)
      } else {
        setIsOpen(!isOpen)
      }
    } else {
      setIsOpen(!isOpen)
    }
  }

  return (
    <div className={`w-full bg-white p-4 landscape:rounded-xl ${className}`}>
      <button className='flex items-center justify-between gap-2 w-full' type='button' onClick={handleClick}>
        <span className='text-base font-semibold font-[Onest]'>{title}</span>
        <img
          src={`${PAGINATION_ICON_URL}/icon-next.svg`}
          alt='arrow-right'
          className={`w-8 transition-transform duration-300 ${isOpen ? 'rotate-90' : 'rotate-0'}`}
        />
      </button>

      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        }`}
      >
        <div className={`overflow-hidden transition-transform duration-300 ${
          isOpen ? 'translate-y-0' : '-translate-y-2'
        }`}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Dropdown
